import * as React from "react";
import CodatErrorsTable from "./CodatErrorsTable";
import CodatError from "../../model/codatErrors/CodatError";
import {none, option, Option} from "ts-option";
import {api} from "../../api/api";
import PageHeaderView from "../body/PageHeaderView";
import PageContentView from "../body/PageContentView";
import PageSelectionComponent from "../v5/table/paginator/PageSelectionComponent";
import {notifyBugsnagAndShowToast} from "../../utils/Utils";
import "./codatErrorsList.scss"
import WorkspaceContainer from "../v5/table/workspace/WorkspaceContainer";

interface State {
	items: Option<CodatError[]>
	page: number,
	totalSize: number,
	markAsResolvedLoading: Option<string>
}

export default class CodatErrorsList extends React.PureComponent<{}, State> {

	constructor(props: {}) {
		super(props);
		this.state = {totalSize: 0, page: 1, items: none, markAsResolvedLoading: none}
	}

	componentDidMount() {
		this.fetchErrors();
	}

	render() {
		return (
			<div className={"c-codat-errors"}>
				<PageHeaderView header={"Codat Errors"}/>
				<PageContentView>
					<PageSelectionComponent itemsNumber={this.state.totalSize}
											itemsPerPage={WorkspaceContainer.PAGE_SIZE}
											currentPageIndex={this.state.page}
											onChange={this.fetchErrors}/>
					<CodatErrorsTable items={this.state.items}
									  onMarkAsResolvedClick={this.markAsResolved}
									  markAsResolvedLoading={this.state.markAsResolvedLoading}/>
				</PageContentView>
			</div>

		)

	}

	fetchErrors = (page: number = this.state.page) => {
		this.setState({items: none}, () =>
			api.instance.codatErrorsApi.fetchErrors(page)
				.then(
					data => this.setState({items: option(data.items.map(CodatError.fromJson)), totalSize: data.totalItems, page}))
				.catch(e => {
					this.setState({totalSize: 0, items: option([])})
					notifyBugsnagAndShowToast(e, "Fetch Codat errors")
				})
		)
	}

	markAsResolved = (errorId: string) => {
		this.setState({markAsResolvedLoading: option(errorId)}, () =>
			api.instance.codatErrorsApi.markErrorAsSolved(errorId)
				.then(() => {
					this.setState({markAsResolvedLoading: none});
					this.fetchErrors()
				})
				.catch(err => {
					this.setState({markAsResolvedLoading: none});
					notifyBugsnagAndShowToast(err, "Mark error as resolved")
				})
		)
	}
}